<template>
<div>
  <div class="flex flex-direction">
		<div class="flex flex-direction">
			<RealTimeAlarm></RealTimeAlarm>
			<videoBox/>
			<div>
				<EquipmentFailure></EquipmentFailure>
			</div>
			<div class="flex">
				<RealTimeAlarmList class="realtimeAlarm flex1"></RealTimeAlarmList>
			
			</div>
		</div>
		<div class="operaBoxRight">
			<BigTitle :bigtitle="bigtitle"></BigTitle>
      <div class="flex">
        <WarningRankingList class="flex1"></WarningRankingList>
        <WarningEventLine class="flex1"></WarningEventLine>
        
      </div>
			<div class="flex">
					<DayAlarm class="flex1"></DayAlarm>
					<AlertType class="flex1"></AlertType>
			</div>
		</div>
	</div>
</div>
	
</template>

<script>
import RealTimeAlarm from "@/components/common/realTimeAlarm";
import RealTimeAlarmList from "@/components/common/realTimeAlarmList";
import DayAlarm from "@/components/common/dayAlarm.vue";
// 设备故障
import EquipmentFailure from "@/components/common/equipmentFailure.vue";
// 预警类型分布
import AlertType from "@/components/common/alertType.vue";
// 预警事件趋势
import WarningEventLine from "@/components/common/warningEventLine.vue";
// 头部
import BigTitle from '../bigTitle';
// 城市预警排名
import WarningRankingList from "@/components/common/warningRankingList.vue";
//视频监控
import videoBox from "@/components/common/videoBox.vue";
import { indexRight } from '@/api/indexRight';
import '@/components/site/imouplayer.js'
export default {
  data () {
    return {
			options: {},
			bigtitle:{
				CHN:'告警分析',
				ENG:'Alarm  Analysis'
			},
			lecheng:false,
			yingshi:true,
			lechengFlag:true,
			stationName:'荆州东岳路换电站'
    };
  },
  components: {
	BigTitle,
	RealTimeAlarm,
	RealTimeAlarmList,
	DayAlarm,
	EquipmentFailure,
	AlertType,
	WarningEventLine,
	WarningRankingList,
	videoBox
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
		
  },
	methods: {
		getKitToken(){
      let _this = this;
			let data = {
				deviceId:'6H03789PAZ65C9C',
				channelIds:'0,1,2,3,4,5,6,7,8'
			}
      indexRight
        .getKitToken(data)
        .then((res) => {
          if(!res) return;
					let src = [];
					res.forEach((item,index) =>(
						src[index] = {
							url: `imou://open.lechange.com/6H03789PAZ65C9C/${item.channelId}/1?streamId=1`, // url拼接说明请见：1.3 轻应用播放地址说明
							kitToken:item.kitToken
						})
					)
					console.log(src,'srccccc')
					this.initKitPlayer(src);
					this.lechengFlag = false;

          
        })
        .catch((err) => {
          console.log(err);
        });
    },
		getAccessToken(){
			indexRight
        .getAccessToken()
        .then((res) => {
          if(!res) return;
          this.initAccessPlayer(res.token);
        })
        .catch((err) => {
          console.log(err);
        });
		},
		initKitPlayer(src){
			const player = new ImouPlayer('#video-lecheng');
			// 播放器初始化
			player.setup({
				src:src, // 播放地址
				poster: '', // 封面图url
				autoplay: true, // 是否自动播放
				controls: true, // 是否展示控制栏
			});
			setTimeout(() => {
					player.setMultiScreen(9);//设置分屏
			}, 1000);
		},
		initAccessPlayer(token){
			let ACCESSTOKEN = token;
			let deviceId = ['C67491518','C67491634','C67491790','C68260588','G01755126','C67491605','D40467206','C67491518','C67491634'];
			let urls = deviceId.map(item=> {
				return `ezopen://SHENGNENG@open.ys7.com/${item}/1.live`
			})
			var player = new EZUIKit.EZUIKitPlayer({
				id: 'video-container', // 荆州
				accessToken: ACCESSTOKEN,
				autoplay: true,
				url: urls.join(),
				splitBasis: 3 //设置窗口切割参数
			})
		},
		//点击左边
		videoArrLClick(){
			if(this.lecheng){
				this.lecheng = false;
				this.yingshi = true;
				this.stationName = "荆州东岳路换电站"
			}	
		},
		//点击右边
		videoArrRClick(){
			if(this.lechengFlag){
				this.getKitToken();
			}
			if(this.yingshi){
				this.lecheng = true;
				this.yingshi = false;		
				this.stationName = "东莞寮步东站换电站"
			}
		}
	},
	mounted () {
		// this.getAccessToken();
		

		// var player1 = new EZUIKit.EZUIKitPlayer({
    //   id: 'video-container1', // 荆州
    //   accessToken: ACCESSTOKEN,
    //   url: 'ezopen://SHENGNENG@open.ys7.com/C67491518/1.live',
    // })
		// var player2 = new EZUIKit.EZUIKitPlayer({
    //   id: 'video-container2', // 荆州
    //   accessToken:ACCESSTOKEN,
    //   url: 'ezopen://SHENGNENG@open.ys7.com/C67491634/1.live',
    // })
		// var player3 = new EZUIKit.EZUIKitPlayer({
    //   id: 'video-container3', // 荆州
    //   accessToken: ACCESSTOKEN,
    //   url: 'ezopen://SHENGNENG@open.ys7.com/C67491790/1.live',
    // })
		// var player4 = new EZUIKit.EZUIKitPlayer({
    //   id: 'video-container4', // 荆州
    //   accessToken: ACCESSTOKEN,
    //   url: 'ezopen://SHENGNENG@open.ys7.com/C68260588/1.live',
    // })
		// var player5 = new EZUIKit.EZUIKitPlayer({
    //   id: 'video-container5', // 荆州
    //   accessToken: ACCESSTOKEN,
    //   url: 'ezopen://SHENGNENG@open.ys7.com/G01755126/1.live',
    // })
		// var player6 = new EZUIKit.EZUIKitPlayer({
    //   id: 'video-container6', // 视频容器ID
    //   accessToken: ACCESSTOKEN,
    //   url: 'ezopen://SHENGNENG@open.ys7.com/D25584218/1.live',
    // })
	}
}
</script>
<style lang="scss" scoped>
.vedioBox{
	display: grid;
	grid-template-columns: 410px 410px 410px;
	grid-template-rows: 232px 232px;
	justify-content: space-between;
	video{
		width: 410px;
		height: 232px;
	}
}
.vedioLecheng{
	width:1230px;
	height:464px;
}
.video-outer{
	position:relative;
	.video-arr{
		position:absolute;
		width:24px;
		height:45px;
		background:url('~@/assets/images/index/arrow_left.png');
		background-size:100% 100%;
		top:50%;
		transform:translateY(-50%);
		cursor: pointer;
	}
	.video-arrL{
		left:-35px;
	}
	.video-arrR{
		background:url('~@/assets/images/index/arrow_right.png');
		background-size:100% 100%;
		right:-35px;

	}
}
.operate{
  div{
    width:33%!important;
  }
}
.stationName{
	position:absolute;
	left:20px;
	top:20px;
	font-size: 24px;
	z-index:1;
}
</style>
